import * as HttpService from "../../../../service/HttpService";


/** 基准曲线  初始化表格  */
export const findCeHkBaseConfigHouseType = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/benchmark/findCeHkBaseConfigHouseType", params);
};

/**查询 基 所有的户型*/
export const findTmTmplHouseType = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/benchmark/findTmTmplHouseType", params);
};

/** 查询有功功率的历史记录**/
export const getHistoricalCurve = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/benchmark/getHistoricalCurve", params);
};
/** 保存设置 **/
export const saveSetting = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/benchmark/saveSetting", params);
};

/** 删除（批量删除设置） **/
export const delSetting = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/benchmark/delSetting", params);
};







